var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScroll = function SvgScroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5,17h0c-1.105,0-2-.895-2-2v-4h1",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15,2h-6c-1.654,0-3,1.346-3,3v10c0,.551-.449,1-1,1s-1,.448-1,1,.448,1,1,1h10c1.654,0,3-1.346,3-3V5c0-1.654-1.346-3-3-3Zm-1,11h-4c-.552,0-1-.448-1-1s.448-1,1-1h4c.552,0,1,.448,1,1s-.448,1-1,1Zm1-5c0,.552-.448,1-1,1h-4c-.552,0-1-.448-1-1v-2c0-.552.448-1,1-1h4c.552,0,1,.448,1,1v2Z",
    fill: "currentColor",
    strokeWidth: 0
  })));
};
export default SvgScroll;